export default "__VITE_ASSET__IQeBitGI__"